export const fetchGitHubStats = async (username) => {
  if (!username) return null;
  
  try {
    const res = await fetch(`https://api.github.com/users/${username}`);
    if (!res.ok) throw new Error("GitHub user not found");
    const data = await res.json();
    return {
      username: data.login,
      avatar: data.avatar_url,
      publicRepos: data.public_repos,
      followers: data.followers,
      following: data.following,
      url: data.html_url
    };
  } catch (err) {
    console.error("GitHub API Error:", err);
    throw err;
  }
};
